/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CompanyWebhookDeliveryTrigger } from "./CompanyWebhookDeliveryTrigger";
import {
  CompanyWebhookDeliveryTriggerFromJSON,
  CompanyWebhookDeliveryTriggerFromJSONTyped,
  CompanyWebhookDeliveryTriggerToJSON,
  CompanyWebhookDeliveryTriggerToJSONTyped,
} from "./CompanyWebhookDeliveryTrigger";
import type { CompanyWebhookDeliveryState } from "./CompanyWebhookDeliveryState";
import {
  CompanyWebhookDeliveryStateFromJSON,
  CompanyWebhookDeliveryStateFromJSONTyped,
  CompanyWebhookDeliveryStateToJSON,
  CompanyWebhookDeliveryStateToJSONTyped,
} from "./CompanyWebhookDeliveryState";
import type { CompanyWebhookEventType } from "./CompanyWebhookEventType";
import {
  CompanyWebhookEventTypeFromJSON,
  CompanyWebhookEventTypeFromJSONTyped,
  CompanyWebhookEventTypeToJSON,
  CompanyWebhookEventTypeToJSONTyped,
} from "./CompanyWebhookEventType";

/**
 *
 * @export
 * @interface CompanyWebhookDelivery
 */
export interface CompanyWebhookDelivery {
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookDelivery
   */
  companyWebhookDeliveryId?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookDelivery
   */
  companyWebhookId?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookDelivery
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookDelivery
   */
  shipmentId?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookDelivery
   */
  eventId?: string;
  /**
   *
   * @type {CompanyWebhookEventType}
   * @memberof CompanyWebhookDelivery
   */
  eventType?: CompanyWebhookEventType;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookDelivery
   */
  webhookUrl?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookDelivery
   */
  requestHeaders?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookDelivery
   */
  requestBody?: string;
  /**
   *
   * @type {CompanyWebhookDeliveryState}
   * @memberof CompanyWebhookDelivery
   */
  state?: CompanyWebhookDeliveryState;
  /**
   *
   * @type {number}
   * @memberof CompanyWebhookDelivery
   */
  attemptCount?: number;
  /**
   *
   * @type {number}
   * @memberof CompanyWebhookDelivery
   */
  httpStatus?: number;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookDelivery
   */
  responseBody?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookDelivery
   */
  errorMessage?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyWebhookDelivery
   */
  nextAttemptAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyWebhookDelivery
   */
  deliveredAt?: OffsetDateTime;
  /**
   *
   * @type {CompanyWebhookDeliveryTrigger}
   * @memberof CompanyWebhookDelivery
   */
  trigger?: CompanyWebhookDeliveryTrigger;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookDelivery
   */
  triggeredByEmail?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyWebhookDelivery
   */
  retriedFromDeliveryId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyWebhookDelivery
   */
  createdAt?: OffsetDateTime;
}

/**
 * Check if a given object implements the CompanyWebhookDelivery interface.
 */
export function instanceOfCompanyWebhookDelivery(
  value: object,
): value is CompanyWebhookDelivery {
  return true;
}

export function CompanyWebhookDeliveryFromJSON(
  json: any,
): CompanyWebhookDelivery {
  return CompanyWebhookDeliveryFromJSONTyped(json, false);
}

export function CompanyWebhookDeliveryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyWebhookDelivery {
  if (json == null) {
    return json;
  }
  return {
    companyWebhookDeliveryId:
      json["companyWebhookDeliveryId"] == null
        ? undefined
        : json["companyWebhookDeliveryId"],
    companyWebhookId:
      json["companyWebhookId"] == null ? undefined : json["companyWebhookId"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    eventId: json["eventId"] == null ? undefined : json["eventId"],
    eventType:
      json["eventType"] == null
        ? undefined
        : CompanyWebhookEventTypeFromJSON(json["eventType"]),
    webhookUrl: json["webhookUrl"] == null ? undefined : json["webhookUrl"],
    requestHeaders:
      json["requestHeaders"] == null ? undefined : json["requestHeaders"],
    requestBody: json["requestBody"] == null ? undefined : json["requestBody"],
    state:
      json["state"] == null
        ? undefined
        : CompanyWebhookDeliveryStateFromJSON(json["state"]),
    attemptCount:
      json["attemptCount"] == null ? undefined : json["attemptCount"],
    httpStatus: json["httpStatus"] == null ? undefined : json["httpStatus"],
    responseBody:
      json["responseBody"] == null ? undefined : json["responseBody"],
    errorMessage:
      json["errorMessage"] == null ? undefined : json["errorMessage"],
    nextAttemptAt:
      json["nextAttemptAt"] == null ? undefined : json["nextAttemptAt"],
    deliveredAt: json["deliveredAt"] == null ? undefined : json["deliveredAt"],
    trigger:
      json["trigger"] == null
        ? undefined
        : CompanyWebhookDeliveryTriggerFromJSON(json["trigger"]),
    triggeredByEmail:
      json["triggeredByEmail"] == null ? undefined : json["triggeredByEmail"],
    retriedFromDeliveryId:
      json["retriedFromDeliveryId"] == null
        ? undefined
        : json["retriedFromDeliveryId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
  };
}

export function CompanyWebhookDeliveryToJSON(
  json: any,
): CompanyWebhookDelivery {
  return CompanyWebhookDeliveryToJSONTyped(json, false);
}

export function CompanyWebhookDeliveryToJSONTyped(
  value?: CompanyWebhookDelivery | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyWebhookDeliveryId: value["companyWebhookDeliveryId"],
    companyWebhookId: value["companyWebhookId"],
    companyId: value["companyId"],
    shipmentId: value["shipmentId"],
    eventId: value["eventId"],
    eventType: CompanyWebhookEventTypeToJSON(value["eventType"]),
    webhookUrl: value["webhookUrl"],
    requestHeaders: value["requestHeaders"],
    requestBody: value["requestBody"],
    state: CompanyWebhookDeliveryStateToJSON(value["state"]),
    attemptCount: value["attemptCount"],
    httpStatus: value["httpStatus"],
    responseBody: value["responseBody"],
    errorMessage: value["errorMessage"],
    nextAttemptAt: value["nextAttemptAt"],
    deliveredAt: value["deliveredAt"],
    trigger: CompanyWebhookDeliveryTriggerToJSON(value["trigger"]),
    triggeredByEmail: value["triggeredByEmail"],
    retriedFromDeliveryId: value["retriedFromDeliveryId"],
    createdAt: value["createdAt"],
  };
}
